<template>
  <footer>
    <p>&copy; Gabriel Voissiere - 2022</p>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/scss/style.scss';
footer {
    width: 100%;
    height: $footerHeight;
    background-color: $blue;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: normal;
}
</style>

